module.exports = __webpack_public_path__ + "img/turkish_eggs_2.b700d267.jpg";